import { render, staticRenderFns } from "./activitySetting.vue?vue&type=template&id=2c96d056&scoped=true"
import script from "./activitySetting.vue?vue&type=script&lang=js"
export * from "./activitySetting.vue?vue&type=script&lang=js"
import style0 from "./activitySetting.vue?vue&type=style&index=0&id=2c96d056&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c96d056",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c96d056')) {
      api.createRecord('2c96d056', component.options)
    } else {
      api.reload('2c96d056', component.options)
    }
    module.hot.accept("./activitySetting.vue?vue&type=template&id=2c96d056&scoped=true", function () {
      api.rerender('2c96d056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/ozonPrint/components/activitySetting.vue"
export default component.exports